import { Navigate, createBrowserRouter } from "react-router-dom";
/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";
import BannerTable from "./modules/admin/pages/cms/banners/list";
import BannerAdd from "./modules/admin/pages/cms/banners/add";
import BannerEdit from "./modules/admin/pages/cms/banners/edit";
import BannerView from "./modules/admin/pages/cms/banners/view";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import FaqTable from "./modules/admin/pages/faq/list";
import FaqAdd from "./modules/admin/pages/faq/add";
import FaqEdit from "./modules/admin/pages/faq/edit";
import InquiryTable from "./modules/admin/pages/inquries/list";
import ViewInquiry from "./modules/admin/pages/inquries/view";
import BabeUserTable from "./modules/admin/pages/babeUser/list";
import BabeUserView from "./modules/admin/pages/babeUser/view";
import BabeUserEdit from "./modules/admin/pages/babeUser/edit";
import BabeAssociateTable from "./modules/admin/pages/babeAssociate/list";
import BabeAssociateView from "./modules/admin/pages/babeAssociate/view";
import BabeAssociateEdit from "./modules/admin/pages/babeAssociate/edit";
import SubscriptionTable from "./modules/admin/pages/subscriptionPlan/list";
import SubscriptionView from "./modules/admin/pages/subscriptionPlan/view";
import SubscriptionEdit from "./modules/admin/pages/subscriptionPlan/edit";
import UserSubscriptionTable from "./modules/admin/pages/userSubscription/list";
import UserSubscriptionDetailView from "./modules/admin/pages/userSubscription/view";
import TransactionTable from "./modules/admin/pages/userTransactions/list";
import TransactionDetailView from "./modules/admin/pages/userTransactions/view";
import EditProfile from "./modules/admin/pages/admin/editprofile";
import Changepassword from "./modules/admin/pages/admin/changepassword";
import Login from "./modules/admin/pages/auth/login";
import ForgotPwdPage from "./modules/admin/pages/auth/forgotpassword";
import OtpVerificationPage from "./modules/admin/pages/auth/otpverification";
import ResetPwdPage from "./modules/admin/pages/auth/resetpwd";
import CompleteAdminProfile from "./modules/admin/pages/admin/completeAdminProfile";
import Profile from "./modules/admin/pages/admin/profile";
import AppointmentList from "./modules/admin/pages/appointment/list";
import RatingList from "./modules/admin/pages/appointmentRatings/list";
import AppointmentView from "./modules/admin/pages/appointment/view";
import RatingDetails from "./modules/admin/pages/appointmentRatings/view";
import WebsiteAboutPage from "./modules/website/pages/aboutPage";
import MeetTheFoundersPage from "./modules/website/pages/meetTheFoundersPage";
import PrivacyPolicyPage from "./modules/website/pages/privacyPolicyPage";
import ContactUs from "./modules/website/pages/ContactUs";
import TermConditionPage from "./modules/website/pages/termsConditionPage";
import FrequentlyAskedQuestions from "./modules/website/pages/frequentlyAskedQuestionsPage";
import DynamicPages from "./modules/website/pages/dynamicPages";
import JobsTable from "./modules/admin/pages/jobs/list";
import ViewSearchedJobs from "./modules/admin/pages/jobs/view";
import BabeReportsTable from "./modules/admin/pages/reports/babeReports/list";
import RevenueDataTable from "./modules/admin/pages/reports/revenueReports/list";
import SMSTemplatesTable from "./modules/admin/pages/cms/smsTemplate/list";
import ViewSMSTemp from "./modules/admin/pages/cms/smsTemplate/view";
import SMSTempEdit from "./modules/admin/pages/cms/smsTemplate/edit";
import SMSTempAdd from "./modules/admin/pages/cms/smsTemplate/add";
import StripeAddAccountSuccess from "./modules/website/pages/StripeAddAccountSuccess";
import StripeAddAccountFailed from "./modules/website/pages/StripeAddAccountFailed";
import ServiceReportsTable from "./modules/admin/pages/reports/servicesReports/list";
import ServiceReportsView from "./modules/admin/pages/reports/servicesReports/view";
import RevenueReportView from "./modules/admin/pages/reports/revenueReports/view";
import BabeReportsView from "./modules/admin/pages/reports/babeReports/view";
import AssociateReportsView from "./modules/admin/pages/reports/associateReports/view";
import UserReportsTable from "./modules/admin/pages/reports/associateReports/list";
import RevealSkyflowImage from "./modules/website/pages/RevealSkyflowImage";
import BostonPreLaunch from "./modules/website/pages/BostonPreLaunch";
import PrelaunchList from "./modules/admin/pages/prelaunch/list";
import PrelaunchView from "./modules/admin/pages/prelaunch/view";
import PendingAppointmentList from "./modules/admin/pages/pendingAppointments/list";
import PendingAppointmentView from "./modules/admin/pages/pendingAppointments/view";
import promoTable from "./modules/admin/pages/promo/list";
import PromoTable from "./modules/admin/pages/promo/list";
import PromoAdd from "./modules/admin/pages/promo/add";
import PromoEdit from "./modules/admin/pages/promo/edit";
import ViewPromo from "./modules/admin/pages/promo/view";
import AssignAssociate from "./modules/admin/pages/pendingAppointments/manualAssignAssociateList";
import PendingAppointmentLogsView from "./modules/admin/pages/pendingAppointments/logs";
import RoleTable from "./modules/admin/pages/role/list";
import RoleAdd from "./modules/admin/pages/role/add";
import RoleEdit from "./modules/admin/pages/role/edit";
import RoleView from "./modules/admin/pages/role/view";
import PermissionTable from "./modules/admin/pages/permission/list";
import PermissionAdd from "./modules/admin/pages/permission/add";
import SubAdminTable from "./modules/admin/pages/subAdmin/list";
import ViewSubAdmin from "./modules/admin/pages/subAdmin/view";
import SubAdminAdd from "./modules/admin/pages/subAdmin/add";
import SubAdminEdit from "./modules/admin/pages/subAdmin/edit";



const router = createBrowserRouter([
  {
    path: "/",
    element: <WebsiteLayout />,
    children: [
      {
        path: "",
        element: <WebsiteHomePage />,
      },
      {
        path: "about",
        element: <WebsiteAboutPage />,
      },
      {
        path: "meetTheFounder",
        element: <MeetTheFoundersPage />,
      },
      {
        path: "privacyPolicy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
      // {
      //   path: "boston-pre-launch",
      //   element: <BostonPreLaunch/>,
      // },
      {
        path: "termsConditions",
        element: <TermConditionPage />,
      },
      {
        path: "frequentlyAskedQuestions",
        element: <FrequentlyAskedQuestions />,
      },
      {
        path: "org-info/:slug",
        element: <DynamicPages />,
      },
      {
        path: "stripe/add-account-success",
        element: <StripeAddAccountSuccess />,
      },
      {
        path: "stripe/add-account-failed",
        element: <StripeAddAccountFailed />,
      },
    ],
  },

  {
    path: "webview/reveal-skyflow-image",
    element: <RevealSkyflowImage />,
  },


  /**ADMIN ROUTE START */
  // {
  //   path: "admin",
  //   element: <PrivateRoute component={AdminLayout} />,
  //   children: [
  //     {
  //       path: "",
  //       element: <Navigate to={"/admin/dashboard"} route="/admin/dashboard" />,
  //     },
  //     {
  //       path: "dashboard",
  //       element: <PrivateRoute component={Dashboard} route="/admin/dashboard" />,
  //     },

  //     {
  //       path: "profile",
  //       // element: <Profile />,
  //       element: <PrivateRoute component={Profile} />,
  //       children: [
  //         {
  //           path: "edit/:id",
  //           // element: <EditProfile />,
  //           element: <PrivateRoute component={EditProfile} />,
  //         },
  //         {
  //           path: "change-password/:id",
  //           // element: <Changepassword />,
  //           element: <PrivateRoute component={Changepassword} />,
  //         },
  //       ],
  //     },

  //     {
  //       /**faq management route start */
  //     },
  //     {
  //       path: "cms/faq-management/faq/list/:pgno",
  //       element: <FaqTable />,
  //     },
  //     // {
  //     //   path: "faq-management/faq/view/:id",
  //     //   element: <TestimonialView />,
  //     // },
  //     {
  //       path: "cms/faq-management/faq/add",
  //       element: <FaqAdd />,
  //     },
  //     {
  //       path: "cms/faq-management/faq/:pgno/edit/:id",
  //       element: <FaqEdit />,
  //     },
  //     {
  //       /**faq-management/faq route end */
  //     },

  //     {
  //       path: "cms/pages/list/:pgno",
  //       element: <PrivateRoute component={PageTable} />,
  //     },
  //     {
  //       path: "cms/pages/add",
  //       element: <PrivateRoute component={PageAdd} />,
  //     },
  //     {
  //       path: "cms/pages/:pgno/edit/:id",
  //       element: <PrivateRoute component={PageEdit} />,
  //     },
  //     {
  //       path: "cms/pages/view/:id",
  //       element: <PrivateRoute component={PageView} />,
  //     },

  //     {
  //       path: "cms/banner/list/:pgno",
  //       element: <PrivateRoute component={BannerTable} />,
  //     },
  //     {
  //       path: "cms/banner/add",
  //       element: <PrivateRoute component={BannerAdd} />,
  //     },
  //     {
  //       path: "cms/banner/:pgno/edit/:id",
  //       element: <PrivateRoute component={BannerEdit} />,
  //     },
  //     {
  //       path: "cms/banner/view/:id",
  //       element: <PrivateRoute component={BannerView} />,
  //     },

  //     {
  //       path: "cms/settings",
  //       element: <PrivateRoute component={GlobalSettings} />,
  //     },

  //     {
  //       path: "cms/default-email-template/list/:pgno",
  //       element: <PrivateRoute component={EmailTemplatesTable} />,
  //     },
  //     {
  //       path: "cms/default-email-template/add",
  //       element: <PrivateRoute component={EmailTempAdd} />,
  //     },
  //     {
  //       path: "cms/default-email-template/:pgno/edit/:id",
  //       element: <PrivateRoute component={EmailTempEdit} />,
  //     },
  //     {
  //       path: "cms/default-email-template/view/:id",
  //       element: <PrivateRoute component={ViewEmailTemp} />,
  //     },


  //     {
  //       path: "cms/sms-template/list/:pgno",
  //       element: <PrivateRoute component={SMSTemplatesTable} />,
  //     },
  //     {
  //       path: "cms/sms-template/add",
  //       element: <PrivateRoute component={SMSTempAdd} />,
  //     },
  //     {
  //       path: "cms/sms-template/:pgno/edit/:id",
  //       element: <PrivateRoute component={SMSTempEdit} />,
  //     },
  //     {
  //       path: "cms/sms-template/view/:id",
  //       element: <PrivateRoute component={ViewSMSTemp} />,
  //     },

  //     {
  //       path: "inquiries/list/:pgno",
  //       element: <PrivateRoute component={InquiryTable} />,
  //     },
  //     {
  //       path: "inquiries/view/:id",
  //       element: <PrivateRoute component={ViewInquiry} />,
  //     },
  //     {
  //       path: "prelaunch/list/:pgno",
  //       element: <PrivateRoute component={PrelaunchList} />,
  //     },
  //     {
  //       path: "prelaunch/view/:id",
  //       element: <PrivateRoute component={PrelaunchView} />,
  //     },

  //     /** babe user routes start from here */
  //     {
  //       path: "babe-user/list/:pgno",
  //       element: <PrivateRoute component={BabeUserTable} />,
  //     },
  //     {
  //       path: "babe-user/view/:_id",
  //       element: <PrivateRoute component={BabeUserView} />,
  //     },
  //     {
  //       path: "babe-user/edit/:_id",
  //       element: <PrivateRoute component={BabeUserEdit} />,
  //     },
  //     /** babe associate routes start from here */
  //     {
  //       path: "babe-associate/list/:pgno",
  //       element: <PrivateRoute component={BabeAssociateTable} />,
  //     },
  //     {
  //       path: "babe-associate/view/:_id",
  //       element: <PrivateRoute component={BabeAssociateView} />,
  //     },
  //     {
  //       path: "babe-associate/edit/:_id",
  //       element: <PrivateRoute component={BabeAssociateEdit} />,
  //     },

  //     /** subscription related route start from here */
  //     {
  //       path: "subscription/subscription-plan/list/:pgno",
  //       element: <PrivateRoute component={SubscriptionTable} />,
  //     },
  //     {
  //       path: "subscription/subscription-plan/view/:_id",
  //       element: <PrivateRoute component={SubscriptionView} />,
  //     },
  //     {
  //       path: "subscription/subscription-plan/edit/:_id",
  //       element: <PrivateRoute component={SubscriptionEdit} />,
  //     },

  //     /**user subscription related route start from here */

  //     /** subscription related route start from here */
  //     {
  //       path: "reports/associate-reports/list/:pgno",
  //       element: <PrivateRoute component={UserReportsTable} />,
  //     },

  //     {
  //       path: "reports/associate-reports/view/:_id",
  //       element: <PrivateRoute component={AssociateReportsView} />,
  //     },
  //     {
  //       path: "reports/babe-reports/list/:pgno",
  //       element: <PrivateRoute component={BabeReportsTable} />,
  //     },
  //     {
  //       path: "reports/babe-reports/view/:_id",
  //       element: <PrivateRoute component={BabeReportsView} />,
  //     },

  //     {
  //       path: "reports/revenue-reports/list/:pgno",
  //       element: <PrivateRoute component={RevenueDataTable} />,
  //     },
  //     {
  //       path: "reports/service-reports/list/:pgno",
  //       element: <PrivateRoute component={ServiceReportsTable} />,
  //     },
  //     {
  //       path: "reports/service-reports/view/:_id",
  //       element: <PrivateRoute component={ServiceReportsView} />,
  //     },
  //     {
  //       path: "reports/revenue-reports/view/:_id",
  //       element: <PrivateRoute component={RevenueReportView} />,
  //     },
  //     // {
  //     //   path: "reports/subscription-plan/edit/:_id",
  //     //   element: <PrivateRoute component={SubscriptionEdit} />,
  //     // },

  //     /**user subscription related route start from here */

  //     {
  //       path: "subscription/user-subscription-plan/list/:pgno",
  //       element: <PrivateRoute component={UserSubscriptionTable} />,
  //     },
  //     {
  //       path: "subscription/user-subscription-plan/view/:_id",
  //       element: <PrivateRoute component={UserSubscriptionDetailView} />,
  //     },

  //     /**user transaction related route start from here */

  //     {
  //       path: "subscription/transaction/list/:pgno",
  //       element: <PrivateRoute component={TransactionTable} />,
  //     },
  //     {
  //       path: "subscription/transaction/view/:_id",
  //       element: <PrivateRoute component={TransactionDetailView} />,
  //     },

  //     /**user appointment related route start from here */

  //     {
  //       path: "appointments/list/:pgno",
  //       element: <PrivateRoute component={AppointmentList} />,
  //     },
  //     {
  //       path: "appointments/view/:_id",
  //       element: <PrivateRoute component={AppointmentView} />,
  //     },

  //     {
  //       path: "appointments/logs/:_id",
  //       element: <PrivateRoute component={PendingAppointmentLogsView} />,
  //     },

  //     {
  //       path: "appointments/assign-associate/list/:_id/:pgno",
  //       element: <PrivateRoute component={AssignAssociate} />,
  //     },




  //       /**user pending appointment related route start from here */

  //       {
  //         path: "pending-appointments/list/:pgno",
  //         element: <PrivateRoute component={PendingAppointmentList} />,
  //       },
  //       {
  //         path: "pending-appointments/view/:_id",
  //         element: <PrivateRoute component={PendingAppointmentView} />,
  //       },

  //       /**user and associate rating related route start from here */

  //     {
  //       path: "ratings/list/:pgno",
  //       element: <PrivateRoute component={RatingList} />,
  //     },
  //     {
  //       path: "ratings/view/:_id",
  //       element: <PrivateRoute component={RatingDetails} />,
  //     },

  //     {
  //       path: "jobs-management/list/:pgno",
  //       element: <PrivateRoute component={JobsTable} />,
  //     },
  //     {
  //       path: "jobs-management/view/:_id",
  //       element: <PrivateRoute component={ViewSearchedJobs} />,
  //     },

  //     {
  //       path: "promotion-management/list/:pgno",
  //       element: <PrivateRoute component={PromoTable} />,
  //     },
  //     {
  //       path: "promotion-management/view/:_id",
  //       element: <PrivateRoute component={ViewPromo} />,
  //     },
  //     {
  //       path: "promotion-management/add",
  //       element: <PrivateRoute component={PromoAdd} />,
  //     },
  //     {
  //       path: "promotion-management/:pgno/edit/:id",
  //       element: <PrivateRoute component={PromoEdit} />,
  //     },

  //     {
  //       path: "staff/list/:pgno",
  //       element: <PrivateRoute component={SubAdminTable} />,
  //     },
  //     {
  //       path: "staff/view/:id",
  //       element: <PrivateRoute component={ViewSubAdmin} />,
  //     },
  //     {
  //       path: "staff/add",
  //       element: <PrivateRoute component={SubAdminAdd} />,
  //     },
  //     {
  //       path: "staff/:pgno/edit/:id",
  //       element: <PrivateRoute component={SubAdminEdit} />,
  //     },
  //     {
  //       path: "role/list/:pgno",
  //       element: <PrivateRoute component={RoleTable} />,
  //     },
  //     {
  //       path: "role/add",
  //       element: <PrivateRoute component={RoleAdd} />,
  //     },
  //     {
  //       path: "role/list/:pgno/edit/:id",
  //       element: <PrivateRoute component={RoleEdit} />,
  //     },
  //     {
  //       path: "role/list/:pgno/view/:id",
  //       element: <PrivateRoute component={RoleView} />,
  //     },
  //     {
  //       path: "permission/list/:pgno",
  //       element: <PrivateRoute component={PermissionTable} />,
  //     },
  //     {
  //       path: "permission/add",
  //       element: <PrivateRoute component={PermissionAdd} />,
  //     },
  //   ],
  // },
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      { path: "", element: <Navigate to={"/admin/dashboard"} /> },
      // { path: "", element: <RedirectToDashboard /> },
      { path: "dashboard", element: <PrivateRoute component={Dashboard} slug="/admin/dashboard" /> },

      // Profile - sab ko allow
      {
        path: "profile",
        element: <PrivateRoute component={Profile} />,
        children: [
          { path: "edit/:id", element: <PrivateRoute component={EditProfile} /> },
          { path: "change-password/:id", element: <PrivateRoute component={Changepassword} /> },
        ],
      },

      // FAQ
      { path: "cms/faq-management/faq/list/:pgno", element: <PrivateRoute component={FaqTable} slug="/admin/cms/faq-management/faq/list" /> },
      { path: "cms/faq-management/faq/add", element: <PrivateRoute component={FaqAdd} slug="/admin/cms/faq-management/faq/add" /> },
      { path: "cms/faq-management/faq/:pgno/edit/:id", element: <PrivateRoute component={FaqEdit} slug="/admin/cms/faq-management/faq/edit" /> },

      // CMS Pages
      { path: "cms/pages/list/:pgno", element: <PrivateRoute component={PageTable} slug="/admin/cms/pages/list" /> },
      { path: "cms/pages/add", element: <PrivateRoute component={PageAdd} slug="/admin/cms/pages/add" /> },
      { path: "cms/pages/:pgno/edit/:id", element: <PrivateRoute component={PageEdit} slug="/admin/cms/pages/edit" /> },
      { path: "cms/pages/view/:id", element: <PrivateRoute component={PageView} slug="/admin/cms/pages/view" /> },

      // CMS Banner
      { path: "cms/banner/list/:pgno", element: <PrivateRoute component={BannerTable} slug="/admin/cms/banner/list" /> },
      { path: "cms/banner/add", element: <PrivateRoute component={BannerAdd} slug="/admin/cms/banner/add" /> },
      { path: "cms/banner/:pgno/edit/:id", element: <PrivateRoute component={BannerEdit} slug="/admin/cms/banner/edit" /> },
      { path: "cms/banner/view/:id", element: <PrivateRoute component={BannerView} slug="/admin/cms/banner/view" /> },

      // CMS Settings
      { path: "cms/settings", element: <PrivateRoute component={GlobalSettings} slug="/admin/cms/settings" /> },

      // Email Template
      { path: "cms/default-email-template/list/:pgno", element: <PrivateRoute component={EmailTemplatesTable} slug="/admin/cms/default-email-template/list" /> },
      { path: "cms/default-email-template/add", element: <PrivateRoute component={EmailTempAdd} slug="/admin/cms/default-email-template/add" /> },
      { path: "cms/default-email-template/:pgno/edit/:id", element: <PrivateRoute component={EmailTempEdit} slug="/admin/cms/default-email-template/edit" /> },
      { path: "cms/default-email-template/view/:id", element: <PrivateRoute component={ViewEmailTemp} slug="/admin/cms/default-email-template/view" /> },

      // SMS Template
      { path: "cms/sms-template/list/:pgno", element: <PrivateRoute component={SMSTemplatesTable} slug="/admin/cms/sms-template/list" /> },
      { path: "cms/sms-template/add", element: <PrivateRoute component={SMSTempAdd} slug="/admin/cms/sms-template/add" /> },
      { path: "cms/sms-template/:pgno/edit/:id", element: <PrivateRoute component={SMSTempEdit} slug="/admin/cms/sms-template/edit" /> },
      { path: "cms/sms-template/view/:id", element: <PrivateRoute component={ViewSMSTemp} slug="/admin/cms/sms-template/view" /> },

      // Inquiries
      { path: "inquiries/list/:pgno", element: <PrivateRoute component={InquiryTable} slug="/admin/inquiries/list" /> },
      { path: "inquiries/view/:id", element: <PrivateRoute component={ViewInquiry} slug="/admin/inquiries/view" /> },

      // Prelaunch
      { path: "prelaunch/list/:pgno", element: <PrivateRoute component={PrelaunchList} slug="/admin/prelaunch/list" /> },
      { path: "prelaunch/view/:id", element: <PrivateRoute component={PrelaunchView} slug="/admin/prelaunch/view" /> },

      // Babe User
      { path: "babe-user/list/:pgno", element: <PrivateRoute component={BabeUserTable} slug="/admin/babe-user/list" /> },
      { path: "babe-user/view/:_id", element: <PrivateRoute component={BabeUserView} slug="/admin/babe-user/view" /> },
      { path: "babe-user/edit/:_id", element: <PrivateRoute component={BabeUserEdit} slug="/admin/babe-user/edit" /> },

      // Babe Associate
      { path: "babe-associate/list/:pgno", element: <PrivateRoute component={BabeAssociateTable} slug="/admin/babe-associate/list" /> },
      { path: "babe-associate/view/:_id", element: <PrivateRoute component={BabeAssociateView} slug="/admin/babe-associate/view" /> },
      { path: "babe-associate/edit/:_id", element: <PrivateRoute component={BabeAssociateEdit} slug="/admin/babe-associate/edit" /> },

      // Subscription
      { path: "subscription/subscription-plan/list/:pgno", element: <PrivateRoute component={SubscriptionTable} slug="/admin/subscription/subscription-plan/list" /> },
      { path: "subscription/subscription-plan/view/:_id", element: <PrivateRoute component={SubscriptionView} slug="/admin/subscription/subscription-plan/view" /> },
      { path: "subscription/subscription-plan/edit/:_id", element: <PrivateRoute component={SubscriptionEdit} slug="/admin/subscription/subscription-plan/edit" /> },

      // User Subscription
      { path: "subscription/user-subscription-plan/list/:pgno", element: <PrivateRoute component={UserSubscriptionTable} slug="/admin/subscription/user-subscription-plan/list" /> },
      { path: "subscription/user-subscription-plan/view/:_id", element: <PrivateRoute component={UserSubscriptionDetailView} slug="/admin/subscription/user-subscription-plan/view" /> },

      // Transaction
      { path: "subscription/transaction/list/:pgno", element: <PrivateRoute component={TransactionTable} slug="/admin/subscription/transaction/list" /> },
      { path: "subscription/transaction/view/:_id", element: <PrivateRoute component={TransactionDetailView} slug="/admin/subscription/transaction/view" /> },

      // Appointments
      { path: "appointments/list/:pgno", element: <PrivateRoute component={AppointmentList} slug="/admin/appointments/list" /> },
      { path: "appointments/view/:_id", element: <PrivateRoute component={AppointmentView} slug="/admin/appointments/view" /> },
      { path: "appointments/logs/:_id", element: <PrivateRoute component={PendingAppointmentLogsView} slug="/admin/appointments/logs" /> },
      { path: "appointments/assign-associate/list/:_id/:pgno", element: <PrivateRoute component={AssignAssociate} slug="/admin/appointments/assign-associate/list" /> },

      // Pending Appointments
      { path: "pending-appointments/list/:pgno", element: <PrivateRoute component={PendingAppointmentList} slug="/admin/pending-appointments/list" /> },
      { path: "pending-appointments/view/:_id", element: <PrivateRoute component={PendingAppointmentView} slug="/admin/pending-appointments/view" /> },


      { path: "ratings/list/:pgno", element: <PrivateRoute component={RatingList} slug="/admin/ratings/list" /> },
      { path: "ratings/view/:_id", element: <PrivateRoute component={RatingDetails} slug="/admin/ratings/view" /> },

      { path: "jobs-management/list/:pgno", element: <PrivateRoute component={JobsTable} slug="/admin/jobs-management/list" /> },
      { path: "jobs-management/view/:_id", element: <PrivateRoute component={ViewSearchedJobs} slug="/admin/jobs-management/view" /> },

      { path: "promotion-management/list/:pgno", element: <PrivateRoute component={PromoTable} slug="/admin/promotion-management/list" /> },
      { path: "promotion-management/view/:_id", element: <PrivateRoute component={ViewPromo} slug="/admin/promotion-management/view" /> },
      { path: "promotion-management/add", element: <PrivateRoute component={PromoAdd} slug="/admin/promotion-management/add" /> },
      { path: "promotion-management/:pgno/edit/:id", element: <PrivateRoute component={PromoEdit} slug="/admin/promotion-management/edit" /> },

      { path: "reports/associate-reports/list/:pgno", element: <PrivateRoute component={UserReportsTable} slug="/admin/reports/associate-reports/list" /> },
      { path: "reports/associate-reports/view/:_id", element: <PrivateRoute component={AssociateReportsView} slug="/admin/reports/associate-reports/view" /> },
      { path: "reports/babe-reports/list/:pgno", element: <PrivateRoute component={BabeReportsTable} slug="/admin/reports/babe-reports/list" /> },
      { path: "reports/babe-reports/view/:_id", element: <PrivateRoute component={BabeReportsView} slug="/admin/reports/babe-reports/view" /> },
      { path: "reports/revenue-reports/list/:pgno", element: <PrivateRoute component={RevenueDataTable} slug="/admin/reports/revenue-reports/list" /> },
      { path: "reports/revenue-reports/view/:_id", element: <PrivateRoute component={RevenueReportView} slug="/admin/reports/revenue-reports/view" /> },
      { path: "reports/service-reports/list/:pgno", element: <PrivateRoute component={ServiceReportsTable} slug="/admin/reports/service-reports/list" /> },
      { path: "reports/service-reports/view/:_id", element: <PrivateRoute component={ServiceReportsView} slug="/admin/reports/service-reports/view" /> },

      { path: "staff/list/:pgno", element: <PrivateRoute component={SubAdminTable} superAdminOnly /> },
      { path: "staff/view/:id", element: <PrivateRoute component={ViewSubAdmin} superAdminOnly /> },
      { path: "staff/add", element: <PrivateRoute component={SubAdminAdd} superAdminOnly /> },
      { path: "staff/:pgno/edit/:id", element: <PrivateRoute component={SubAdminEdit} superAdminOnly /> },
      { path: "role/list/:pgno", element: <PrivateRoute component={RoleTable} superAdminOnly /> },
      { path: "role/add", element: <PrivateRoute component={RoleAdd} superAdminOnly /> },
      { path: "role/list/:pgno/edit/:id", element: <PrivateRoute component={RoleEdit} superAdminOnly /> },
      { path: "role/list/:pgno/view/:id", element: <PrivateRoute component={RoleView} superAdminOnly /> },
      { path: "permission/list/:pgno", element: <PrivateRoute component={PermissionTable} superAdminOnly /> },
      { path: "permission/add", element: <PrivateRoute component={PermissionAdd} superAdminOnly /> },
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:email",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },

  { path: "admin/*", element: <Error404 /> },
], {
  future: {
    v7_relativeSplatPath: true
  },
});

export default router;
